import { UnexpectedLineItemRequest } from './error';
import { LineItemRequest } from './LineItemRequest';
export class RealTimeLineItemRequest extends LineItemRequest {
    constructor(locationId) {
        super(locationId);
    }
}
export function assertIsRealTimeLineItemRequest(lineItemRequest, message) {
    if (!isRealTimeLineItemRequest(lineItemRequest)) {
        throw typeof message === 'object'
            ? message
            : new UnexpectedLineItemRequest(message !== null && message !== void 0 ? message : `Expected ${RealTimeLineItemRequest.name}, but received ${lineItemRequest.constructor.name}`);
    }
}
export function isRealTimeLineItemRequest(lineItemRequest) {
    return lineItemRequest instanceof RealTimeLineItemRequest;
}
